import { IUnidEntityAddRequest } from '../../../../model/scp/entity/request/unid-entity-add-request';

export type UnidEntityCreateState = {
  request: IUnidEntityAddRequest;
  showValidationErrors: boolean;
};

export enum ACTION_TYPES {
  setRequest = 'setRequest',
  updateRequest = 'updateRequest',
  setShowValidationErrors = 'setShowValidationErrors',
}

export const UnidEntityCreateReducer = (state: UnidEntityCreateState, action: any): UnidEntityCreateState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setRequest:
      return {
        ...state,
        request: payload,
      };
    case ACTION_TYPES.updateRequest:
      return {
        ...state,
        request: {
          ...state.request,
          ...payload,
        },
      };
    case ACTION_TYPES.setShowValidationErrors:
      return {
        ...state,
        showValidationErrors: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
